module.exports = __webpack_public_path__ + "img/reactance.a1879e2e.jpeg";